import { Component, OnInit } from '@angular/core';
import { User } from '@sb-shared/models/user';
import { ProfileDataService } from '../../services/profile-data.service';

@Component({
    selector: 'sb-profile-permission-to-walk',
    templateUrl: './profile-permission-to-walk.component.html',
    styleUrls: ['./profile-permission-to-walk.component.scss'],
    standalone: false
})
export class ProfilePermissionToWalkComponent implements OnInit {

  selectedPerson: User;

  constructor(private profileData: ProfileDataService) { }

  ngOnInit(): void {
    this.profileData.getUserInContext().subscribe(user => {
      this.selectedPerson = user;
    });
  }
}
